<template>
  <div class="checkbox form-group"
       :class="{ checked, semiChecked, 'no-label': !label }">
    <input type="checkbox"
           :name="fid"
           :value="checkboxvalue ? checkboxvalue : 1"
           :checked="checked"
           :id="fid"
           :disabled="readonly"
           @input="handleInput"/>
    <label class="mb-0" :for="fid">{{ label }}<slot/></label>
  </div>
</template>

<script setup>
import {computed} from "vue"

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  label: {},
  modelValue: {},
  semiChecked: {
    type: Boolean,
    default: false
  },
  fid: {},
  readonly: {},
  checkboxvalue: {

  }
})

const checked = computed(() => {
  return props.checkboxvalue ? (Array.isArray(props.modelValue) ? props.modelValue.includes(props.checkboxvalue) : (props.modelValue == props.checkboxvalue)) : props.modelValue
})

const handleInput = (e) => {
  if(props.checkboxvalue) {
    let c = props.modelValue
    if(Array.isArray(c)) {
      let ind = c.indexOf(props.checkboxvalue)
      if (ind === -1) {
        c.push(props.checkboxvalue)
      } else {
        c.splice(ind, 1)
      }
    } else {
      if(e.target.checked) {
        c = props.checkboxvalue
      } else {
        c = 0
      }
    }
    emit('update:modelValue', c)
  } else {
    emit('update:modelValue', e.target.checked)
  }
}
</script>
